/** Gerador de documentos: contrato de trabalho, aditivo, avisos, declarações e fichas cadastrais, a partir do cadastro. */
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { GerarDocumento, ModelosDeDocumento } from '../telas/gerador/gerador';
import { Tabs } from '../ui/layout';

const Busca = z.object({ aba: z.enum(['gerar', 'modelos']).optional(), cliente: z.string().optional(), funcionario: z.string().optional(), modelo: z.string().optional(), /** documento de uma alteração contratual (aditivo ou contrato novo) */ alteracao: z.string().optional(), doc: z.enum(['aditivo', 'contrato']).optional() });
export const Route = createFileRoute('/_app/documentos')({ validateSearch: Busca, component: Documentos });

function Documentos() {
  const s = Route.useSearch();
  const nav = useNavigate({ from: Route.fullPath });
  const aba = s.aba ?? 'gerar';
  return (
    <>
      <div className="topbar"><div><h1>Gerador de documentos</h1><div className="sub">contrato de trabalho, aditivo, avisos, declarações e ficha cadastral — preenchidos pelo cadastro, em PDF na pasta do cliente</div></div></div>
      <div className="conteudo">
        <Tabs valor={aba} onChange={(v) => void nav({ search: (p) => ({ ...p, aba: v }) })} itens={[{ id: 'gerar', rotulo: 'Gerar documento' }, { id: 'modelos', rotulo: 'Modelos' }]} />
        {aba === 'gerar' ? <GerarDocumento key={s.alteracao ?? 'livre'} inicial={{ cliente: s.cliente, funcionario: s.funcionario, modelo: s.modelo, alteracao: s.alteracao, doc: s.doc }} /> : <ModelosDeDocumento />}
      </div>
    </>
  );
}
